import { useCallback, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setScreen } from "../../actions/loginActions";
import { performCheckIdentityForgetPassword } from "@delorean/actions/resetPasswordActions";
import { LoginResetPswFormType } from "@delorean/login/schemas/login";
import { LoginScreen } from "@delorean/login";
import { LoginResetPswType, PasswordResetScreen } from "../types";
import { useErrorContext } from "@delorean/_shared/context/ErrorContext";
import { useTranslation } from "react-i18next";
import {
  CaptchaActionEnum,
  useCaptcha,
} from "@delorean/_shared/hooks/useCaptcha";
export const useForgetPasswordIdentityForm = () => {
    const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showError } = useErrorContext();
  const { getCaptchaToken } = useCaptcha();
  
  const setCurrentScreen = useCallback(
    (screenType: LoginScreen | PasswordResetScreen) => {
      dispatch(setScreen(screenType));
    },
    [dispatch]
  );

  const { error, loading, screen } = useSelector(
    (state: RootStateOrAny) => state.login
  );
  const qrCodeValue = useSelector(
    (state: RootStateOrAny) => state.login.mfaData.appData
  );

  const submit = async (values: LoginResetPswType) => {
    try {
      console.log("Getting captcha token for reset password...");
      const captchaToken = await getCaptchaToken(CaptchaActionEnum.RESET_PASSWORD);
      dispatch(
        performCheckIdentityForgetPassword(
          values.contractCode,
          values.userCode,
          values.fiscalCode,
          captchaToken,
        )
      );
    } catch (error) {
      console.error("Error obtaining captcha token:", error);
      if (error && typeof error === "object" && "message" in error) {
        throw new Error((error as { message: string }).message);
      } else {
        throw new Error("An unknown captcha error occurred");
      }
    }
  };

  useEffect(() => {
    if (error) {
      showError(t("login.authFailure.verifyIdentity"));
    }
  }, [error]);

  return {
    loading,
    submit,
    screen,
    qrCodeValue,
    setCurrentScreen,
  };
};
